/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
// import { useStaticQuery, graphql } from "gatsby";
import Header from './header';
import Footer from './footer';

import '../css/global.css';

const Layout = ({ children }) => {
  // const data = useStaticQuery(graphql`
  //   query SiteTitleQuery {
  //     site {
  //       siteMetadata {
  //         title
  //       }
  //     }
  //   }
  // `)

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-100">
        <main>{children}</main>
        <Footer />
      </div>
    </>
  )
}


export default Layout;
